import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { compose } from 'redux';
import { ToastContainer } from 'react-toastify';

import history from '../history';
import AdminLayout from '../layouts/Admin';
import AuthLayout from '../layouts/Auth';
import 'react-toastify/dist/ReactToastify.css';
const App = ({ token }) => (
  <Router history={history}>
    <Switch>
      <Route path="/auth" component={AuthLayout} />
      <Route
        path="/admin"
        render={props => {
          if (token) {
            return <AdminLayout {...props} />;
          }

          window.requestedUrl =
            window.location.pathname + history.location.search;
          return <Redirect to="/auth/login" />;
        }}
      />
      <Redirect from="/" to="/admin/dashboard" />
    </Switch>
    <ToastContainer
      style={{ fontSize: '14px', whiteSpace: 'pre-wrap' }}
      position="top-right"
      autoClose={6000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={true}
      rtl={false}
      pauseOnFocusLoss={true}
      draggable={true}
      pauseOnHover={true}
      theme="light"
    />
  </Router>
);

const mapStateToProps = ({ Auth }) => ({ token: Auth.token });

const enhance = compose(connect(mapStateToProps, null));

export default enhance(App);
